module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMBAMAAACQIoDIAAAAKlBMVEVHcEzyMjLyMjL/Pj7yMzP0NzfyMjLyNDTyMjLyNDTxMzPzMzPzMjLyMjLXgd+3AAAADXRSTlMAw/IMsSVlT5g74n5/1dQA9gAAAGFJREFUCNdjcDRgAANmEQZZYQjT8CJD1BUI03cpA6tuA4jFcSmAgWHSbRDzrCaQYL+bwMDAdrcAJJB7nYGh9hpYA/elCZy6GyCae1WDbkBYDCy31jpAmcyyF6FWAm0C2wgAbywUp5eigKgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/NewCourseDetail/images/coupon_down.png
// module id = 1156
// module chunks = 1